<template>
  <div class="w-full">
    <div class="flex items-center gap-[6px] text-[12px] text-[#737373]">
      <TBFCardToggleItem
        label="Komship"
        :active="activeTab === 'komship'"
        @click="switchTab('komship')"
      />
      <span class="size-[3px] bg-[#737373] rounded-full" />
      <TBFCardToggleItem
        label="Non Komship"
        :active="activeTab === 'kompack'"
        @click="switchTab('kompack')"
      />
      <span class="size-[3px] bg-[#737373] rounded-full" />
      <TBFCardToggleItem
        label="Marketplace"
        :active="activeTab === 'marketplace'"
        @click="switchTab('marketplace')"
      />
    </div>
    <p
      :class="{
        'pt-[8px] mb-0 select-text cursor-text leading-[normal]': true,
        'text-black text-[24px] font-[600]': !loadingSummaries,
        'bg-gray-200 rounded-[8px] h-[21px] animate-pulse w-[76%]': loadingSummaries,
      }"
      @click.prevent.stop
    >
      {{ loadingSummaries ? '' : transactionAmount | rupiah }}
    </p>
  </div>
</template>

<script>
import TBFCardToggleItem from './TBFCardToggleItem.vue'

/**
 * Component untuk menampilkan content summary dari transaksi biaya fulfillment
 */
export default {
  components: {
    TBFCardToggleItem,
  },
  props: {
    summariesData: {
      type: Object,
      required: true,
    },
    loadingSummaries: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 'kompack',
    }
  },
  computed: {
    /**
     * Data transaksi pickup kompack
     * @returns {number} Data transaksi pickup kompack
     */
    transactionAmount() {
      if (this.activeTab === 'komship') {
        return this.summariesData.transaction_pickup_komship
      }
      if (this.activeTab === 'marketplace') {
        return this.summariesData.transaction_pickup_marketplace
      }
      return this.summariesData.transaction_pickup_kompack
    },
  },
  methods: {
    switchTab(tabName) {
      this.activeTab = tabName
    },
  },
}
</script>
